import React from "react";
import { linkifyText } from "../../utils/linkify";

/**
 * Renders text with clickable links (http/https/www + Google Forms/Docs).
 */
const LinkifiedText = ({ text, own = false }) => {
  if (!text) return null;

  const segments = linkifyText(text);
  const linkClass = own
    ? "underline text-blue-100 hover:text-white break-all"
    : "underline text-blue-600 hover:text-blue-800 break-all";

  return (
    <span className="text-sm whitespace-pre-wrap break-words">
      {segments.map((seg, i) => {
        if (seg.type === "link") {
          return (
            <a
              key={i}
              href={seg.href}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClass}
              title={seg.isGoogle ? "Open Google link" : "Open link"}
              onClick={(e) => e.stopPropagation()}
            >
              {seg.value}
              {seg.isGoogle ? " ↗" : ""}
            </a>
          );
        }
        return <React.Fragment key={i}>{seg.value}</React.Fragment>;
      })}
    </span>
  );
};

export default LinkifiedText;
